module.exports = __webpack_public_path__ + "img/scadaImg.b7068ec5.png";